import { createMuiTheme } from "@material-ui/core/styles";

const MainTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#4fb848",
      contrastText: "#fff",
    },
  },
  props: {
    MuiButton: {
      variant: "contained",
    },
    MuiTextField: {
      variant: "outlined",
      margin: "dense",
    },
    // MuiInputLabel: {
    //   shrink: true,
    // },
  },
  overrides: {
    MuiPaper: {
      root: {
        padding: "15px",
      },
    },
    MuiTextField: {
      root: {
        marginBottom: 10,
        "& .MuiFormHelperText-root": {
          position: "absolute",
          background: "#fff",
          bottom: -9,
        },
      },
    },
    MuiButtonBase: {
      root: {
        borderRadius: 4,
      },
    },
  },
});

export default MainTheme;
